import { createClient } from '@supabase/supabase-js';
import { getEnvValue } from '../utils/env';

// Resolve URL/key from multiple env shapes
const resolvedSupabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  process.env.SUPABASE_URL ||
  getEnvValue('REACT_APP_SUPABASE_URL', 'SUPABASE_URL');

const resolvedSupabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  process.env.SUPABASE_ANON_KEY ||
  getEnvValue('REACT_APP_SUPABASE_ANON_KEY', 'SUPABASE_ANON_KEY');

// Validate required environment variables
if (!resolvedSupabaseUrl || !resolvedSupabaseAnonKey) {
  const missingVars = [];
  if (!resolvedSupabaseUrl) missingVars.push('REACT_APP_SUPABASE_URL');
  if (!resolvedSupabaseAnonKey) missingVars.push('REACT_APP_SUPABASE_ANON_KEY');

  const errorMsg = `[Supabase] Missing required environment variables: ${missingVars.join(', ')}. Check your .env file.`;

  if (process.env.NODE_ENV === 'development') {
    console.error(errorMsg);
    // In development, show a visible error but don't crash to allow debugging
  } else {
    // In production, this is a critical configuration error
    throw new Error(errorMsg);
  }
}

const supabaseUrl = resolvedSupabaseUrl || '';
const supabaseAnonKey = resolvedSupabaseAnonKey || '';

export const resolvedSupabaseConfig = {
  supabaseUrl,
  supabaseAnonKey,
  usingFallback: !resolvedSupabaseUrl || !resolvedSupabaseAnonKey
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: {
    headers: {
      apikey: supabaseAnonKey
    }
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce' // ensure modern session handling in SPA
  },
  realtime: {
    params: {
      eventsPerSecond: 2
    }
  }
});

// Database types for TypeScript support (simplified for compatibility)
export const Database = {
  Tables: {
    countries: {
      Row: {},
      Insert: {},
      Update: {}
    },
    languages: {
      Row: {},
      Insert: {},
      Update: {}
    },
    translations: {
      Row: {},
      Insert: {},
      Update: {}
    },
    immigration_pathways: {
      Row: {},
      Insert: {},
      Update: {}
    }
  }
};
